var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 41.85V11.675C55 8.67498 52.55 6.44998 49.575 6.69998H49.425C44.175 7.14998 36.2 9.82498 31.75 12.625L31.325 12.9C30.6 13.35 29.4 13.35 28.675 12.9L28.05 12.525C23.6 9.74998 15.65 7.09998 10.4 6.67498C7.425 6.42498 5 8.67498 5 11.65V41.85C5 44.25 6.95 46.5 9.35 46.8L10.075 46.9C15.5 47.625 23.875 50.375 28.675 53L28.775 53.05C29.45 53.425 30.525 53.425 31.175 53.05C35.975 50.4 44.375 47.625 49.825 46.9L50.65 46.8C53.05 46.5 55 44.25 55 41.85Z",
    stroke: "#1DB954",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.7251V51.2251",
    stroke: "#1DB954",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 21.2251H13.75",
    stroke: "#1DB954",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 28.7251H13.75",
    stroke: "#1DB954",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b1559bdf4697ce55a7b6b96d9b2fd72b.svg";
export { ForwardRef as ReactComponent };